module.exports = __webpack_public_path__ + "img/banklogo-2.a0ad0ac3.png";